




import Vue from 'vue';
import Component from 'vue-class-component';
import {  Prop , Provide } from 'vue-property-decorator';
import { ConfiguratorService , ConfiguratorServiceSettings } from '../../services/sketchfab/index';
import  { Store } from '@/store';

import { Types, ConfigurationServiceInitiated } from '@/models/events';




@Component
export default class SketchfabFrame extends Vue {
  public initiated:boolean = false;

  @Prop([String])
  sketchfabModelId: string;

  @Prop([String])
  textureBaseUrl: string;

  async mounted () {
    if (this.initiated) {
      return;
    }

    const el = (<Element>this.$refs.iframe);

    const settings = new ConfiguratorServiceSettings();
    settings.modelId = this.sketchfabModelId;
    settings.textureBaseUrl = this.textureBaseUrl;
    const service = await ConfiguratorService.init(el,settings);
    Store.setConfiguratorService(settings.modelId, service);
    this.initiated = true;
    this.$root.$emit(Types.ConfigurationServiceInitiatedEvent, {
      sketchfabModelId: this.sketchfabModelId,

    } as ConfigurationServiceInitiated);
  }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/skecthfabFrame/SketchfabFrame.vue